import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  save(attrs) {
    const url = apiRoutes.buyerBidRequestPath();

    return FetchHelpers.post(url, attrs);
  },
  open(attrs) {
    const url = apiRoutes.buyerOpenBidRequestPath();

    return FetchHelpers.post(url, attrs);
  },
  saveAndOpen(attrs) {
    const url = apiRoutes.buyerSaveAndOpenBidRequest();

    return FetchHelpers.post(url, attrs);
  },
  show() {
    const url = apiRoutes.buyerBidRequestPath();

    return FetchHelpers.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/buyer/BidRequestRepository.js